﻿//type:tiled|dynamic|image
//存放样式的
var appmapConfig = {}
var appmapConfig_list = [
    {
        judge: "http://localhost:", //浏览器地址判断   本地跑的
    },
    {
        judge: "http://58.213.48.110", //浏览器地址判断   本地跑的
    },
];

function appmapConfig_list_1() {
    // body...
    var arr = appmapConfig_list;
    var str = location.href;
    for (var i = 0; i < arr.length; i++) {
        var patt1 = new RegExp(arr[i].judge);
        var result = patt1.test(str);
        if (result == true) {
            appmapConfig = arr[i];
            return
        }
    }
}
appmapConfig_list_1();


//////////////////
// WEBPACK FOOTER
// ./static/config/mapConfig.js
// module id = 1126
// module chunks = 1